import { takeEvery, call, put, select, takeLatest } from 'redux-saga/effects';
import { push, LOCATION_CHANGE } from 'react-router-redux';
import {
    SubmissionError,
    actionTypes as reduxFormActionTypes,
} from 'redux-form';
import { combineReducers } from 'redux';
import queryString from 'query-string';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';
import { SYNC_LOGGED_IN_USER } from './app';
import { SET_ME } from './me';
import POSITION_TYPES from '../../constants/position-types';
import { showAlert } from './alert';
import { markAsSeenAction } from './notifications';
import NOTIFICATIONS from '../../constants/notifications';

export const LOGIN = 'auth/LOGIN';
export const LOGOUT = 'auth/LOGOUT';
export const TOKEN_UPDATED = 'auth/TOKEN_UPDATED';
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const AUTHENTICATION_ERROR = 'auth/AUTHENTICATION_ERROR';
export const CHANGE_PASSWORD = 'auth/CHANGE_PASSWORD';
export const FETCH_PASSWORD_SALT = 'auth/FETCH_PASSWORD_SALT';
export const FORGET_PASSWORD = 'auth/FORGET_PASSWORD';
export const CHECK_RESET_PASSWORD = 'auth/CHECK_RESET_PASSWORD';
export const AUTH_LEVEL_CHECK = 'auth/AUTH_LEVEL_CHECK';
export const REFRESH = 'auth/REFRESH';
export const SIGNUP = 'auth/SIGNUP';
export const ACTIVATE_USER = 'auth/ACTIVATE_USER';
export const SET_INVITE_CODE = 'auth/SET_INVITE_CODE';
export const SET_INVITED_EMAIL = 'auth/SET_INVITED_EMAIL';
export const CHANGE_MERGE_REQUEST = 'auth/CHANGE_MERGE_REQUEST';
export const SEND_MERGE_REQUEST = 'auth/SEND_MERGE_REQUEST';
export const MERGE_ACCOUNT = 'auth/MERGE_ACCOUNT';
export const CONNECT_ACCOUNT_REQUEST = 'auth/CONNECT_ACCOUNT_REQUEST';
export const CONNECT_ACCOUNT_VERIFY = 'auth/CONNECT_ACCOUNT_VERIFY';
export const VALIDATE_EMAIL = 'auth/VALIDATE_EMAIL';
export const VALIDATE_COUPON = 'auth/VALIDATE_COUPON';
export const PROCESS_PAYMENT = 'auth/PROCESS_PAYMENT';
export const UNIVERSAL_LOGIN_LIST = 'auth/UNIVERSAL_LOGIN_LIST';
export const GET_BANNER_FLAG = 'auth/GET_BANNER_FLAG';
export const GET_BANNER_MESSAGE = 'auth/GET_BANNER_MESSAGE';

export const levelReducer = (state = null, action) => {
    switch (action.type) {
        case actionKey.success(AUTH_LEVEL_CHECK):
            return parseInt(action.payload, 10);
        case SET_ME: {
            if (action.payload.level) {
                return parseInt(action.payload.level, 10);
            }
            return state;
        }
        case actionKey.success(SIGNUP):
            if (action.payload.level) {
                return action.payload.level;
            }
            return state;
        case LOGOUT:
        case AUTHENTICATION_ERROR:
            return null;
        default:
            return state;
    }
};

export const tokenReducer = (state = null, action) => {
    switch (action.type) {
        case SYNC_LOGGED_IN_USER:
            return action.payload.token;
        case TOKEN_UPDATED:
            return action.token;
        case LOGOUT:
        case AUTHENTICATION_ERROR:
            return null;
        default:
            return state;
    }
};

export const resetPasswordReducer = (state = {}, action) => {
    switch (action.type) {
        case CHECK_RESET_PASSWORD:
            return {
                loading: true,
            };
        case actionKey.success(CHECK_RESET_PASSWORD):
            return {
                userId: action.payload.split(':')[1],
            };
        case AUTHENTICATION_ERROR:
        case actionKey.failure(CHECK_RESET_PASSWORD):
            return {
                error: true,
            };
        case LOCATION_CHANGE:
            return {};
        default:
            return state;
    }
};

export const activateUserReducer = (state = {}, action) => {
    switch (action.type) {
        case ACTIVATE_USER:
            return {
                loading: true,
                error: false,
            };
        case actionKey.success(ACTIVATE_USER):
            return {
                error: false,
            };
        case actionKey.failure(ACTIVATE_USER):
            return {
                error: true,
            };
        default:
            return state;
    }
};

export const connectVerifyReducer = (state = {
    loading: true,
}, action) => {
    switch (action.type) {
        case CONNECT_ACCOUNT_VERIFY:
            return {
                loading: true,
                error: false,
            };
        case actionKey.success(CONNECT_ACCOUNT_VERIFY):
            return {};
        case actionKey.failure(CONNECT_ACCOUNT_VERIFY):
            return {
                error: action.error,
            };
        default:
            return state;
    }
};

export const inviteCodeReducer = (state = null, action) => {
    switch (action.type) {
        case LOCATION_CHANGE: {
            const { search } = action.payload;
            if (!search) {
                return state;
            }
            const {
                invite,
            } = queryString.parse(search);
            if (invite) {
                return invite;
            }
            return state;
        }
        default:
            return state;
    }
};

export const invitedEmailReducer = (state = null, action) => {
    switch (action.type) {
        case LOCATION_CHANGE: {
            const { search } = action.payload;
            if (!search) {
                return state;
            }
            const {
                email,
            } = queryString.parse(search);
            if (email) {
                return email;
            }
            return state;
        }
        default:
            return state;
    }
};

export const mergeRequestModal = (state = null, action) => {
    switch (action.type) {
        case CHANGE_MERGE_REQUEST:
            return action.payload;
        case actionKey.success(SEND_MERGE_REQUEST):
        case actionKey.success(MERGE_ACCOUNT):
            return null;
        default:
            return state;
    }
};

export const mergeStatus = (state = {}, action) => {
    switch (action.type) {
        case MERGE_ACCOUNT:
            return {
                loading: true,
            };
        case actionKey.success(MERGE_ACCOUNT):
            return {
                success: true,
            };
        case actionKey.failure(MERGE_ACCOUNT):
            return {
                error: action.error,
            };
        default:
            return state;
    }
};

export const ssoLoginReducer = (state = false, action) => {
    console.log(' login action type', action.type)
    switch (action.type) {
        case AUTH_LEVEL_CHECK:
            return !!action.tag;
        case actionKey.success(CONNECT_ACCOUNT_VERIFY):
            console.log('succes login', actionKey.success(GET_BANNER_FLAG))
            return true;
        case actionKey.success(LOGIN):
            return !!action.body.connect;
        default:
            console.log('default login', action.type)
            return state;
    }
};

export const universalLoginReducer = (state = null, action) => {
    if (action.type === actionKey.success(UNIVERSAL_LOGIN_LIST)) {
        return action.payload.access;
    }
    return state;
};

export const discountReducer = (state = null, action) => {
    switch (action.type) {
        case actionKey.success(VALIDATE_COUPON):
            return action.payload.discount;
        case actionKey.failure(VALIDATE_COUPON):
            return null;
        case reduxFormActionTypes.CHANGE: {
            const {
                field,
                form,
            } = action.meta;
            if (field === 'couponCode' && form === 'signup') {
                return null;
            }
            return state;
        }
        default:
            return state;
    }
};

export const bannerFlagReducer = (state = {}, action) => {

    switch (action.type) {
        case GET_BANNER_FLAG:
            return { ...state };
        case actionKey.success(GET_BANNER_FLAG):
            return action.payload.setting;
        default:

            return state;
    }
};

export const bannerMessageReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_BANNER_MESSAGE:
            return { ...state };
        case actionKey.success(GET_BANNER_MESSAGE):

            return action.payload.setting;
        default:
            return state;
    }
};

export default combineReducers({
    level: levelReducer,
    token: tokenReducer,
    resetPassword: resetPasswordReducer,
    activated: activateUserReducer,
    connectVerify: connectVerifyReducer,
    inviteCode: inviteCodeReducer,
    invitedEmail: invitedEmailReducer,
    mergeRequestModal,
    mergeStatus,
    ssoLogin: ssoLoginReducer,
    universalLogin: universalLoginReducer,
    discount: discountReducer,
    bannerFlag: bannerFlagReducer,
    bannerMessage: bannerMessageReducer
});

export const authLevelCheckAction = ({ tag, resolve } = {}) => ({
    type: AUTH_LEVEL_CHECK,
    tag,
    resolve,
});

export const loginAction = ({ userName, password, connect, reject, resolve }) => ({
    type: LOGIN,
    userName,
    password,
    connect,
    reject,
    resolve,
});

export const connectAccountRequestAction = ({ userName, connect, reject, resolve }) => ({
    type: CONNECT_ACCOUNT_REQUEST,
    connect,
    userName,
    reject,
    resolve,
});

export const connectVerifyAction = connect => ({
    type: CONNECT_ACCOUNT_VERIFY,
    connect,
});

export const logoutAction = () => ({
    type: LOGOUT,
});

export const authErrorAction = (data = {}) => ({
    type: AUTHENTICATION_ERROR,
    ...data,
});

export const updateTokenAction = token => ({
    type: TOKEN_UPDATED,
    token,
});

export const checkResetPasswordAction = token => ({
    type: CHECK_RESET_PASSWORD,
    token,
});

export const resetPasswordAction = ({ newPassword, reject, resolve }) => ({
    type: RESET_PASSWORD,
    newPassword,
    resolve,
    reject,
});

export const changePasswordAction = ({ newPassword, reject, resolve }) => ({
    type: CHANGE_PASSWORD,
    newPassword,
    resolve,
    reject,
});

export const forgetPasswordAction = ({ email, reject, resolve }) => ({
    type: FORGET_PASSWORD,
    email,
    resolve,
    reject,
});

export const signupAction = args => ({
    type: SIGNUP,
    ...args,
});

export const activateUserAction = token => ({
    type: ACTIVATE_USER,
    token,
});

export const startMergeRequestAction = email => ({
    type: CHANGE_MERGE_REQUEST,
    payload: email,
});

export const closeMergeRequestAction = () => ({
    type: CHANGE_MERGE_REQUEST,
    payload: null,
});

export const sendMergeRequestAction = (email, { resolve, reject }) => ({
    type: SEND_MERGE_REQUEST,
    email,
    resolve,
    reject,
});

export const mergeAccountAction = ({ email, password, token }, { resolve, reject } = {}) => ({
    type: MERGE_ACCOUNT,
    payload: { email, password, token },
    resolve,
    reject,
});

export const validateEmailAction = ({ email }, { reject, resolve } = {}) => ({
    type: VALIDATE_EMAIL,
    payload: { email },
    reject,
    resolve,
});

export const validateCouponAction = ({ couponCode }, { reject, resolve } = {}) => ({
    type: VALIDATE_COUPON,
    payload: { couponCode },
    reject,
    resolve,
});

export const processPaymentAction = ({ stripeToken, couponCode }, { reject, resolve } = {}) => ({
    type: PROCESS_PAYMENT,
    payload: { stripeToken, couponCode },
    reject,
    resolve,
});


export const universalLoginListAction = () => ({
    type: UNIVERSAL_LOGIN_LIST,
});

export const getBannerFlagAction = ({ reject, resolve } = {}) => ({
    type: GET_BANNER_FLAG,
    reject,
    resolve,
});

// export const getBannerFlagAction = showBanner => ({
//     type: GET_BANNER_FLAG,
//     payload: { showBanner }
// });

export const getBannerMessageAction = ({ reject, resolve } = {}) => ({
    type: GET_BANNER_MESSAGE,
    reject,
    resolve,
});

/**
 * SAGA LISTENERS
 */

export function* loginSaga({ type, userName, password, connect, resolve, reject }) {
    const result = yield call(login, {
        type,
        userName,
        password,
        connect,
    });
    if (result && result.error) {
        let error = result.error || 'Something went wrong';
        if (result.status === 401) {
            error = 'Wrong email or password.';
        } else if (result.status === 402) {
            error = 'Expired';
        }
        return yield reject(new SubmissionError({
            _error: error,
        }));
    }
    return yield resolve(result);
}

export const refreshAction = () => ({ type: REFRESH });

export function* rootSaga() {
    yield [
        takeEvery(LOGIN, loginSaga),
        takeEvery(CHANGE_PASSWORD, changePassword),
        takeEvery(RESET_PASSWORD, changePassword),
        takeEvery(FORGET_PASSWORD, forgetPassword),
        takeEvery(CHECK_RESET_PASSWORD, checkResetPassword),
        takeEvery(AUTH_LEVEL_CHECK, authLevelCheck),
        takeEvery(SIGNUP, signup),
        takeEvery(ACTIVATE_USER, activateUser),
        takeEvery(actionKey.success(ACTIVATE_USER), authLevelCheck),
        takeEvery(actionKey.success(SIGNUP), redirectToConfirmEmail),
        takeEvery(REFRESH, refresh),
        takeEvery(SEND_MERGE_REQUEST, sendMergeRequest),
        takeEvery(MERGE_ACCOUNT, mergeAccount),
        takeEvery(CONNECT_ACCOUNT_REQUEST, connectAccountRequest),
        takeEvery(CONNECT_ACCOUNT_VERIFY, connectAccountVerify),
        takeEvery(actionKey.success(CONNECT_ACCOUNT_VERIFY), authLevelCheck),
        takeLatest(VALIDATE_EMAIL, validateEmail),
        takeLatest(VALIDATE_COUPON, validateCoupon),
        takeEvery(PROCESS_PAYMENT, processPayment),
        takeEvery(LOCATION_CHANGE, paymentRequiredCheck),
        takeEvery(UNIVERSAL_LOGIN_LIST, fetchUniversalLoginList),
        takeEvery(GET_BANNER_FLAG, getBannerFlag),
        takeEvery(GET_BANNER_MESSAGE, getBannerMessage)
    ];
}

/**
 * SAGA ACTIONS
 */

export function* fetchUniversalLoginList({ type }) {
    yield call(request, {
        type,
        url: '/api/auth/universal-login/list',
    });
}


export function* login({ type, userName, password, connect }) {
    const body = {
        userName,
        password,
        connect,
    };
    return yield call(request, {
        type,
        url: '/api/auth/login',
        options: {
            method: 'POST',
            body,
        },
        body,
    });
}

export function* authLevelCheck({ tag, resolve }) {
    let url = '/api/auth/maxauthlevel';
    if (tag) {
        url = `${url}?temptag=${tag}`;
    }
    yield call(request, {
        type: AUTH_LEVEL_CHECK,
        url,
        options: {
            method: 'POST',
            headers: {
                accept: 'text/plain',
                'Content-Type': 'application/json',
            },
        },
        responseType: 'text',
    });
    if (resolve) {
        yield resolve();
    }
}

export function getCompanyPositions({ companyPositions, positionType }) {
    // check for not listed position
    if (Number(positionType) === POSITION_TYPES.EMPLOYEE && companyPositions === 0) {
        return [];
    }
    return !Array.isArray(companyPositions) && companyPositions ?
        [companyPositions] : companyPositions;
}

export function* signup({
    type,
    firstName,
    lastName,
    email,
    password,
    zipCode,
    positionType,
    stripeToken,
    companyPositions,
    leadiD,
    spartanUserType,
    couponCode,
    reject,
    resolve,
}) {
    const {
        auth: { inviteCode },
    } = yield select();

    const body = {
        password,
        userName: email,
        firstName,
        lastName,
        zip: zipCode,
        positionType,
        companyPositions: getCompanyPositions({ companyPositions, positionType }),
        stripeToken,
        inviteCode,
        leadiD,
        spartanUserType,
        couponCode,
    };
    const result = yield call(request, {
        url: '/api/auth/signup',
        type,
        options: {
            method: 'POST',
            body,
        },
        body,
    });

    if (result && result.error) {
        yield reject(new SubmissionError({
            _error: result.error,
        }));
        return;
    }

    yield resolve();
}

function* redirectToConfirmEmail({ body }) {
    const { auth } = yield select();
    // check if user is already verified
    // by checking if his token is present
    if (auth.token) {
        return;
    }
    yield put(push('/confirm-email', { email: body.userName }));
}

export function* activateUser({ type, token }) {
    yield call(request, {
        url: '/api/auth/activate-user',
        options: {
            method: 'POST',
            body: {
                token,
            },
            headers: {
                accept: 'text/plain',
            },
        },
        type,
        responseType: 'text',
    });
}

export function* changePassword({ newPassword, type, reject, resolve }) {
    const passwordChange = yield call(request, {
        url: '/api/auth/change-password',
        options: {
            method: 'POST',
            body: {
                newPassword,
            },
        },
        type,
    });
    if (passwordChange && passwordChange.error) {
        yield reject(new SubmissionError({
            _error: passwordChange.error,
        }));
        return;
    }
    yield resolve();
}

export function* checkResetPassword({ type, token }) {
    if (!token) {
        yield put({
            type: actionKey.failure(type),
        });
        return;
    }
    yield call(request, {
        url: '/api/auth/check-reset-password',
        type,
        options: {
            method: 'POST',
            body: {
                token,
            },
            headers: {
                accept: 'text/plain',
                AuthToken: null,
            },
        },
        responseType: 'text',
    });
}

export function* forgetPassword({ type, email, reject, resolve }) {
    const result = yield call(request, {
        url: '/api/auth/forget-password',
        type,
        options: {
            method: 'POST',
            body: {
                email,
            },
        },
    });
    if (result.error) {
        yield reject(new SubmissionError({
            _error: result.error || 'Something went wrong',
        }));
    } else if (!result.payload.success) {
        yield reject(new SubmissionError());
    } else if (result.payload.success) {
        yield resolve();
    }
}

export function* refresh({ type }) {
    yield call(request, {
        url: '/api/auth/refresh',
        type,
        options: {
            headers: {
                accept: 'text/plain',
            },
        },
        responseType: 'text',
    });
}

export function* sendMergeRequest({ type, email, resolve, reject }) {
    const result = yield call(request, {
        url: '/api/auth/send-merge-request',
        type,
        options: {
            method: 'POST',
            body: {
                secondaryEmail: email,
            },
        },
    });

    if (result.error) {
        yield reject(new SubmissionError({
            _error: result.error || 'Something went wrong',
        }));
    } else if (!result.payload.success) {
        yield reject(new SubmissionError());
    } else {
        yield resolve();
        yield put(markAsSeenAction(NOTIFICATIONS.SECONDARY_EMAIL, false));
        yield put(showAlert({
            title: 'Success!',
            message: 'An email has been sent with instructions to complete the merge process.',
            type: 'success',
            button: 'Close',
        }));
    }
}

const noop = () => null;

export function* mergeAccount({ type, payload, resolve = noop, reject = noop }) {
    const body = {};
    if (payload.token) {
        body.mergeToken = payload.token;
    } else {
        body.secondaryEmail = payload.email;
        body.password = payload.password;
    }
    const result = yield call(request, {
        type,
        url: '/api/auth/merge-accounts',
        options: {
            method: 'POST',
            body,
        },
    });

    if (result && result.error) {
        reject(new SubmissionError({
            _error: result.error,
        }));
        return;
    }
    resolve();
    if (!payload.token) {
        yield put(showAlert({
            title: 'Success!',
            message: 'The account has been merged',
            type: 'success',
            button: 'Close',
        }));
    }
}

export function* connectAccountRequest({ type, connect, userName, resolve = noop, reject = noop }) {
    const result = yield call(request, {
        type,
        url: '/api/auth/connect-request',
        options: {
            method: 'POST',
            body: {
                connect,
            },
        },
    });

    if (result && result.error) {
        reject(new SubmissionError({
            _error: result.error,
        }));
        return;
    }
    yield put(push('/confirm-connect', { email: userName }));
    resolve();
}

export function* connectAccountVerify({ type, connect }) {
    yield call(request, {
        type,
        url: '/api/auth/verify-connect',
        options: {
            method: 'POST',
            body: {
                connect,
            },
        },
    });
}

export function* validateEmail({ type, payload, resolve, reject }) {
    const result = yield call(request, {
        type,
        url: '/api/auth/validate-email',
        options: {
            method: 'POST',
            body: payload,
        },
    });

    if (result && result.error) {
        reject({
            email: result.error,
        });
        return;
    }
    resolve();
}

export function* validateCoupon({ type, payload, resolve, reject }) {
    const result = yield call(request, {
        type,
        url: '/api/auth/validate-coupon',
        options: {
            method: 'POST',
            body: payload,
        },
    });

    if (result && result.error) {
        reject({
            couponCode: result.error,
        });
        return;
    }
    resolve();
}

export function* processPayment({ type, payload, resolve, reject }) {
    const result = yield call(request, {
        type,
        url: '/api/auth/stripe-charge',
        options: {
            method: 'POST',
            body: payload,
        },
    });

    if (result && result.error) {
        reject(new SubmissionError({
            _error: result.error,
        }));
        return;
    }
    resolve();
}

export function* paymentRequiredCheck({ payload }) {
    if (payload.pathname === '/process-payment' || payload.pathname === '/logout') {
        return;
    }

    const {
        auth,
        me,
        theme,
    } = yield select();

    if (!isAuthenticated(auth) || !me) {
        return;
    }

    if (me.isPaying) {
        return;
    }

    if (!Number(theme.price || 0)) {
        return;
    }

    yield put(push('/process-payment'));
}

export function* getBannerFlag({ type, resolve = noop, reject = noop }) {

    const res = yield call(request, {
        url: `/api/setting/Maintenance`,
        type,
        options: {
            method: 'GET',
        },
    });

    if (res.error && reject) {
        reject(res.error);
    } else if (!res.error && resolve) {

        resolve(res.payload);
    }
}

export function* getBannerMessage({ type, resolve = noop, reject = noop }) {

    const res = yield call(request, {
        url: `/api/setting/BannerMessage`,
        type,
        options: {
            method: 'GET',
        },
    });

    if (res.error && reject) {
        reject(res.error);
    } else if (!res.error && resolve) {
        resolve(res.payload);
    }
}

export const isAuthenticated = ({ token, level }) => !!token && !!level;



// WEBPACK FOOTER //
// ./src/client/redux/auth.js